import { useState } from 'react';
import DatePickerWrapper from '../Datepicker/DatepickerWrapper';
import { Tooltip } from 'react-tooltip';
import { useTranslation } from 'react-i18next';
import { set } from 'date-fns';

interface FormDatePickerProps {
  form: any;
  startDateName: string;
  endDateName: string;
  label?: string;
  isRange?: boolean;
  required?: boolean;
  className?: string;
  isCase?: boolean;
  disabled?: boolean;
}

export const FormDatePicker: React.FC<FormDatePickerProps> = ({
  form,
  startDateName,
  endDateName,
  label,
  isRange = true,
  required = false,
  className = '',
  isCase = false,
  disabled = false,
}) => {
  const { t } = useTranslation();
  return (
    <div className={`form-element ${className}`} style={{position: 'relative'}}>
      {label && (
        <label>
          {label}
          {required ? '*' : ''}
        </label>
      )}
      <div className="form-date-picker-wrapper">
        <form.Field
          name={startDateName}
          validators={{
            onBlur: ({ value }: any) => {
              if (required && value === null) {
                return t('This field is required');
              }
              return undefined;
            },
            onChange: ({ value }: any) => {
              if (required && value === null) {
                return t('This field is required');
              }
              return undefined;
            },
          }}
          onSubmit={(e: any) => e.preventDefault()}
          children={(startField: any) => {
            const hasErrorValue = startField.state.meta.errors?.length > 0;
            const errorMessageValue = startField.state.meta.errors?.[0] || '';
            return (
              <>
              <form.Field
                name={endDateName}
                onSubmit={(e: any) => e.preventDefault()}
                children={(endField: any) => (
                  <DatePickerWrapper
                    onChange={(startDate: Date | null, endDate: Date | null) => {
                      startField.handleChange(startDate);
                      endField.handleChange(endDate);
                    }}
                    initStartDate={startField.state.value}
                    initEndDate={endField.state.value}
                    isRange={isRange}
                    formError={hasErrorValue ? errorMessageValue : ''}
                    disabled={disabled}
                  />
                )}
              />
              
              </>
              
            )
          }}
        />

        {isCase && (
          <form.Field
            name="isCaseOpen"
            children={(field: any) => {
              return (
                <span className="open-case-settings form-checkbox-group">
                  <span
                    className="form-checkbox"
                    data-tooltip-id="open-case-tooltip"
                    data-tooltip-content={t(
                      'Continuously fetches new results without end date',
                    )}
                  >
                    <input
                      type="checkbox"
                      id="open-case"
                      checked={field.state.value}
                      onChange={(e) => field.handleChange(e.target.checked)}
                      disabled={disabled}
                    />
                    <label className="label" htmlFor="open-case">
                      {t('Ongoing Case')}
                    </label>
                  </span>
                  <Tooltip id="open-case-tooltip" place="top" />
                </span>
              );
            }}
          />
        )}
      </div>
    </div>
  );
};
